<template lang="html">
  <!--  <div>
        <h1>Signup Form</h1>
        <form @submit.prevent="signup">
            <b-form-group label="Enter your user id">
                <b-form-input type="text" v-model="uid"></b-form-input>
            </b-form-group>
            <b-form-group label="Enter your password">
                <b-form-input type="password" v-model="password"></b-form-input>
            </b-form-group>
            <b-form-group label="Enter your position">
                <b-select v-model="position" :options="positionOptions"></b-select>
            </b-form-group>
            <b-form-group label="Enter your role">
                <b-select v-model="role" :options="roleOptions"></b-select>
            </b-form-group>
            <b-button size="lg" variant="success" type="submit">Signup</b-button>
        </form>
    </div> -->

 <div class="container">
    <div class="card o-hidden border-0 shadow-lg my-5">
      <div class="card-body p-0">
        <!-- Nested Row within Card Body -->
        <div class="row">
          <div class="col-lg-5 d-none d-lg-block bg-register-image"></div>
          <div class="col-lg-7">
            <div class="p-5">
              <div class="text-center">
                <h1 class="h4 text-gray-900 mb-4">Create an Account!</h1>
              </div>
              <form class="user" @submit.prevent="signup">
                  <!--
                <div class="form-group row">
                  <div class="col-sm-6 mb-3 mb-sm-0">
                    <input type="text" class="form-control form-control-user" id="exampleFirstName" placeholder="First Name">
                  </div>
                  <div class="col-sm-6">
                    <input type="text" class="form-control form-control-user" id="exampleLastName" placeholder="Last Name">
                  </div>
                </div>
                -->
                <div class="form-group">
                  <input type="text" v-model="uid" class="form-control form-control-user" placeholder="Id">
                </div>
                <div class="form-group row">
                  <div class="col-sm-6 mb-3 mb-sm-0">
                    <input type="password" v-model="password" class="form-control form-control-user" placeholder="Password">
                  </div>
                  <div class="col-sm-6">
                    <input type="password" v-model="r_password" class="form-control form-control-user" placeholder="Repeat Password">
                  </div>
                </div>
                   <div class="form-group row">
                  <div class="col-sm-6 mb-3 mb-sm-0">
                <b-select v-model="position" :options="positions"></b-select>
                  </div>
                  <div class="col-sm-6">
                <b-select v-model="role" :options="roles"></b-select>
                  </div>
                </div>
                  <hr>
                <button type="submit"  class="btn btn-primary btn-user btn-block">
                  Register Account
                </button>
              
                <!-- <a href="index.html" class="btn btn-google btn-user btn-block">
                  <i class="fab fa-google fa-fw"></i> Register with Google
                </a>
                <a href="index.html" class="btn btn-facebook btn-user btn-block">
                  <i class="fab fa-facebook-f fa-fw"></i> Register with Facebook
                
                </a> -->
              </form>
                <hr>
              <div class="text-center">
                    <a class="small" href="" @click="notice">Forgot Password?</a>
              </div>
              <div class="text-center">
                <router-link :to="{ name:'Signin' }" class="small">Already have an account? Login!</router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import VueResource from 'vue-resource';
    import {secretKey} from '@/config/config';
    import crypto from 'crypto-js';
    import axios from 'axios';

    export default {
        name: 'Signup',
        data () {
            return {
                uid: '',
                password: '',
                r_password: '',
                role: null,
                position: null,
                positions: [
                    { text: 'Enter your position', value : null},
                    { text: '개발자', value: 'developer' },
                    { text: '기획자', value: 'director' },
                    { text: '디자이너', value: 'designer' },
                ],
                roles: [
                    { text: 'Enter your role', value : null},
                    { text: '일반', value: 'member' },
                    { text: '관리자', value: 'admin' },
                ]
            };
        },
        methods: {
             notice(){
              alert("준비중 입니다.");  
            },
            signup () {
                const uid = this.uid;
                let password = this.password;
                const r_password = this.r_password;
                let position = this.position;
                const role = this.role;
                const router = this.$router;
                const apiHost = this.$apiHost
                
                if (!uid) {
                    alert('아이디를 입력해 주세요.');
                    return false;
                }
                if (!password){
                    alert('비밀번호를 입력해 주세요.');
                    return false
                }
                if (!position){
                    alert('Position을 입력해 주세요.');
                    return false;
                }
                if (!role){
                    alert('role을 입력해 주세요.');
                    return false;
                }
                if(password!=r_password){
                  alert('비밀번호를 확인해 주세요.');
                  return false;
                }

                //aes 암호화
               password = crypto.AES.encrypt(password,secretKey).toString(); 
                   axios.post(apiHost+'/auth/signup', { uid, password, position, role })
                    .then(res => {
                        if (res.status === 200) {
                          alert('가입 성공');
                            // 성공적으로 회원가입이 되었을 경우
                            router.push({ name: 'Signin' });
                        }else{
                          alert('로그인에 실패하였습니다. code: '+res.status);
                        }
                    });
               
            }
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    h1, h2 {
        font-weight: normal;
    }

    ul {
        list-style-type: none;
        padding: 0;
    }

    li {
        display: inline-block;
        margin: 0 10px;
    }

    a {
        color: #42b983;
    }

    .btn-lg {
        width: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/views/User/Signup.vue